export default {
  // Title
  tip: "Tip",

  // Content
  temporaryCanvasPrompt:
    "Sorry, this is currently a temporary canvas. Do you want to save this canvas?",
  exitTemporaryCanvasPrompt:
    "This is a temporary canvas. It will not exist after exiting. Please save the canvas if you want to keep it. Do you want to exit?",

  // Buttons
  no: "No",
  yes: "Yes",
  exit: "Exit",
  saveCanvas: "Save Canvas",
};
